import React from 'react';
import { IconButton, InputAdornment, TextField, Tooltip } from '@mui/material';
import AutorenewIcon from '@mui/icons-material/Autorenew';

import i18n from '../../i18n';
import { generateWebhookSecret } from '../../utils/webhookSecret';

/**
 * A text field with a generate button, for credentials the operator invents.
 *
 * Deliberately not masked. The webhook secret is shared with Telegram and with
 * nobody else, it is write-only over the API so the field is blank on every edit
 * anyway, and hiding it would only stop the operator checking what they are about
 * to save.
 */
export default class DialogSecretField extends React.Component {
    generate = () => {
        this.props.onChange(this.props.field.id, generateWebhookSecret());
    };

    render() {
        const { field, value, error, autoFocus, onBlur } = this.props;
        // FormField passes this when a template locks the form. DialogTextField
        // ignores it; a field with a button that writes a value must not.
        const disabled = Boolean(this.props.disabled);
        const translatedName = i18n.t(`columns.${field.label}`);

        return (
            <TextField
                key={field.id}
                autoFocus={autoFocus}
                id={field.id}
                label={translatedName}
                type="text"
                required={Boolean(field.required)}
                error={Boolean(error)}
                helperText={error || (field.helperText ? i18n.t(`helperTexts.${field.helperText}`) : '')}
                value={value || ''}
                disabled={disabled}
                fullWidth
                onBlur={onBlur}
                onChange={(event) => this.props.onChange(event.target.id, event.target.value)}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <Tooltip title={i18n.t('common.generate')}>
                                {/* The span is not decoration: MUI's Tooltip needs a
                                    child that fires events, and a disabled button
                                    fires none — it warns and shows no tooltip. */}
                                <span>
                                    {/* tabIndex -1: tabbing through the form should
                                        reach the next field, not a button that
                                        overwrites what was just typed. */}
                                    <IconButton
                                        onClick={this.generate}
                                        edge="end"
                                        tabIndex={-1}
                                        disabled={disabled}
                                    >
                                        <AutorenewIcon />
                                    </IconButton>
                                </span>
                            </Tooltip>
                        </InputAdornment>
                    )
                }}
            />
        );
    }
}
